<template>
    <div>
        <div v-if="dialogVisible">
            <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit('form')">
                <el-form-item label="Instruction" prop="content">
                    <el-input v-model="form.content" placeholder="Enter detailed instruction" type="textarea" :autosize="{ minRows: 2 }"></el-input>
                </el-form-item>
                <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
                <el-button @click="onCancel('form')">Cancel</el-button>
            </el-form>
        </div>
        <div v-else>
            <el-button type="primary" size="mini" @click="setVisible(true)">
                Add Step
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            dialogVisible: false,
            form: {
                content: '',
            },
            rules: {
                content: [
                    { required: true, message: 'Enter an instruction.', trigger: 'blur' },
                ],
            },
        }
    },

    props: {
        ingredientId: {
            required: true,
            type: String,
        },
    },

    methods: {
        onSubmit(form) {
            this.loading = true

            this.$refs[form].validate(async valid => {
                if (!valid) {
                    this.loading = false

                    return false
                }

                try {
                    var { data } = await this.$http.post(`/ingredient-steps`, {
                        ingredient_id: this.ingredientId,
                        content: this.form.content,
                    })
                } catch(err) {
                    this.$message.error(err.response.data.message)

                    return false
                } finally {
                    this.loading = false
                }

                this.setVisible(false)
                this.$refs[form].resetFields()
                this.$emit('create')
                this.$message.success(data.message)
            })
        },

        onCancel(form) {
            this.setVisible(false)
            this.$refs[form].resetFields()
        },

        setVisible(status) {
            this.dialogVisible = status
        },
    },
}
</script>
